<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section id="ngx-datatable-shipping">
            <div class="card">
                <div class="card-title d-flex justify-content-between align-items-center">
                    <h4>Envíos</h4>
                    <div class="d-flex justify-content-between align-items-center pr-2"> 
                    <button class="btn btn-primary" rippleEffect (click)="OpenCreateModal()">
                        <i data-feather="plus" class="mr-0 mr-sm-1"></i><span class="d-none d-sm-inline-block">Nuevo
                            Envío</span>
                    </button>
                    <button type="button" placement="left" (click)="OpenModalSearch()" data-toggle="modal" data-target="#myModal"
                class="btn btn-icon btn-info ml-2 pl-2 text-danger cursor-pointer"
                
                height="16"
                rippleEffect                 
                >
                <span>
                    <i class="fa fa-bars fa-lg" style="color:#ffff"></i>                    
                    Filtrar                   
                  </span></button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div  [formGroup]="searchFrm"class="d-flex justify-content-between align-items-center m-1">
                                <!--<label class="d-flex align-items-center">Mostrando
                                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option *ngIf="shippings.length > 15" [value]="shippings.length">Todos</option>
                                    </select>
                                    envíos</label>--> 
                                    <mat-form-field class="search_inbar">
                                        <mat-label>Buscar por Código</mat-label>                                        
                                        <input
                                          matInput
                                          formControlName="text"
                                          #searchInput
                                          placeholder="Teclea para filtrar"                                          
                                        />
                                        <button *ngIf="this.searchFrm.get('text').value" matSuffix mat-icon-button aria-label="Clear" (click)="clearInputFilter()">
                                            <mat-icon>close</mat-icon>
                                          </button>                                        
                                      </mat-form-field>                                   
                            </div>
                        </div>
                        <div class="col-md-6 col-12 d-flex justify-content-md-end">
                            <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                                
                                <!--<label class="d-flex align-items-center">Buscar</label><input #searchInput type="search"
                                        class="form-control ml-25 mb-1"
                                        (keyup)="FilterUpdate(searchInput.value)"
                                        (search)="FilterUpdate(searchInput.value)" />-->
                                        <button class="btn btn-success align-items-center ml-1 mb-1" type="button" (click)="export()" [disabled]="!shippingBillsShow?.length">
                                            <em class="fa fa-print"></em>
                                          </button>
                            </div>
                        </div>
                    </div>
                    

                    <table mat-table #outerSort="matSort" [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                        <ng-container matColumnDef="code">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
                            <td mat-cell *matCellDef="let element">
                                <a class="text-wrap" *ngIf="element.bills?.data?.length > 0; else sinVuelos" [routerLink]="'/pages/shipping-summary/' + element.id" target="_self" placement="right"
                                ngbTooltip="Ver Facturas">
                                  {{ GetCodeById(element.id) }}</a
                                >
                                <ng-template #sinVuelos>
                                   {{ element.code }}
                                </ng-template>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo envío</th>
                            <td mat-cell *matCellDef="let element">{{ element.shippingTypeName }}</td>
                        </ng-container>   
                        <ng-container matColumnDef="desciption">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Descripción</th>
                            <td mat-cell *matCellDef="let element">{{ element.description }}</td>
                        </ng-container>                      
                        <ng-container matColumnDef="created">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Creado</th>
                            <td mat-cell *matCellDef="let element">{{ element.createAt | date: "dd/MM/yyyy" }}</td>
                        </ng-container>  
                        <ng-container matColumnDef="cost">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Gastos</th>
                            <td mat-cell *matCellDef="let element">{{ element.totalCost }}</td>
                        </ng-container> 
                        <ng-container matColumnDef="state">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
                            <td mat-cell *matCellDef="let element"> <div class="badge badge-pill" [ngClass]="{
                                'badge-light-primary': GetState(element.closeAt),
                                'badge-light-danger': !GetState(element.closeAt)
                            }">
                {{ GetState(element.closeAt) ? 'Abierto' : 'Cerrada' }}</div></td>
                        </ng-container>    
                        <td mat-footer-cell *matFooterCellDef> {{totalCost}} </td>                   
                        
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap">Acciones</th>
                            <td mat-cell class="justify-content-center text-center" *matCellDef="let element">
                                <button class="btn btn-outline-light text-primary dropbtn" [ngbPopover]="popoverTemplate"
                                    #popOver="ngbPopover" data-container="body" placement="left-top" [autoClose]="'outside'" type="button"
                                    id="defaultDropdown" aria-expanded="false">
                                    <em class="fa fa-bars"></em>
                                </button>
                    
                                <ng-template #popoverTemplate style="overflow: visible;">
                                    <div>
                                        <button type="button" ngbTooltip="Vuelos" placement="left"
                                            class="btn btn-outline-primary btn-icon text-primary cursor-pointer mr-50" rippleEffect
                                            (click)="OpenFlightsModal(element.id)">
                                            <span [data-feather]="'send'"></span></button>
                                        <button type="button" ngbTooltip="Gastos" placement="left"
                                            class="btn btn-outline-success btn-icon text-success cursor-pointer mr-50" rippleEffect
                                            (click)="OpenExpensesModal(element.id)">
                                            <span [data-feather]="'file-text'"></span></button>
                                        <button type="button" ngbTooltip="Editar" placement="left"
                                            class="btn btn-outline-info btn-icon text-info cursor-pointer mr-50" rippleEffect
                                            (click)="OpenCreateModal(element.id)">
                                            <span [data-feather]="'edit'"></span></button>
                                            <button type="button" *ngIf="checkIfFlightHasBills(element.id)" ngbTooltip="Imprimir etiquetas" placement="left" (click)="generateShippingLabelsPDF(element.id)" 
                    class="btn btn-icon btn-outline-primary text-primary cursor-pointer mr-50" rippleEffect>
                    <span [data-feather]="'printer'"></span></button>
                                        <button type="button" (click)="Delete(element.id)" ngbTooltip="Eliminar" placement="left"
                                            *ngIf="ShowDelete(element.id)"
                                            class="btn btn-outline-danger btn-icon text-danger cursor-pointer" rippleEffect>
                                            <span [data-feather]="'trash-2'"></span></button>
                                    </div>
                    
                                </ng-template>
                            </td>
                        </ng-container>                        
                    
                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="expandedDetail">
                            <td
                              mat-cell
                              *matCellDef="let element"
                              [attr.colspan]="columnsToDisplay.length"
                            >
                              <div
                                class="example-element-detail"
                                *ngIf="element.bills?.data?.length"
                                [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
                              >
                                <div class="inner-table mat-elevation-z8" *ngIf="expandedElement">
                                  
                                  <table
                                    #innerTables
                                    mat-table
                                    #innerSort="matSort"
                                    [dataSource]="element.bills"
                                    matSort
                                    multiTemplateDataRows
                                  >             

                                    <ng-container matColumnDef="code">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
                                        <td mat-cell *matCellDef="let element">{{ element.billCode }} <br> {{ element.serviceCode }}</td>
                                    </ng-container>  
                                    <ng-container matColumnDef="pounds">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Peso</th>
                                        <td mat-cell *matCellDef="let element">{{ element.billPounds | number: '1.2-2' }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="province">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Provincia</th>
                                        <td mat-cell *matCellDef="let element">{{ element.province }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="municipality">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Municipio</th>
                                        <td mat-cell *matCellDef="let element">{{ element.municipality }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="state">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
                                        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="actions">
                                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                                        <td mat-cell *matCellDef="let element">
                                            <div>
                                                <button type="button" *ngIf="element.shipingType == 1" ngbTooltip="Imprimir etiqueta" placement="left" (click)="generateBillLabelsPDF(element)" 
                class="btn btn-icon btn-outline-primary text-primary cursor-pointer mr-50" rippleEffect>
                <span [data-feather]="'printer'"></span></button>
                                            </div>
                                            
                                        </td>
                                    </ng-container>
                        
                                    <!-- Expanded SubContent Column - The subdetail row is made up of this one column that spans across all columns -->
                                    <ng-container matColumnDef="expandedSubDetail">
                                      <td
                                        mat-cell
                                        *matCellDef="let element"
                                        [attr.colspan]="innerDisplayedColumns.length"
                                      >                        
                                       
                                      </td>
                                    </ng-container>
                        
                                    <tr mat-header-row *matHeaderRowDef="innerDisplayedColumns"></tr>                                    
                                    <tr
                                      mat-row
                                      *matRowDef="let row; columns: innerDisplayedColumns;"
                                    ></tr>
                                  </table>
                                </div>
                              </div>
                            </td>
                          </ng-container>
                        
                          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                          <tr
                            mat-row
                            *matRowDef="let element; columns: columnsToDisplay;"
                            [class.example-element-row]="element.bills?.data?.length"
                            [class.example-expanded-row]="expandedElement === element"
                            (click)="toggleRow(element)"
                          ></tr>
                          <tr
                            mat-row
                            *matRowDef="let row; columns: ['expandedDetail']"
                            class="example-detail-row" [class.example-expanded-row]="expandedSubElement === element"
                          ></tr>
                    </table>
                    <mat-paginator
                    *ngIf="this.shippingBillsShow.length > 0"
                    (page)="handlePageEvent($event)"
  #paginator
  [length]="totalRecords"
  [pageSizeOptions]="pageSizeOptions"
  showFirstLastButtons
></mat-paginator>
                    
                    <!--
                    <ngx-datatable [rows]="shippings" [rowHeight]="58" class="bootstrap core-bootstrap"
                        [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [scrollbarH]="true"
                        [limit]="basicSelectedOption"
                        [messages]="{emptyMessage: 'No hay información para mostrar', totalMessage: 'Total de envíos'}">
                        <ngx-datatable-column name="Código" [width]="100" prop="">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <a class="text-wrap" [routerLink]="'/pages/shipping-summary/' + row.id" target="_self" placement="right"
                                ngbTooltip="Ver Facturas">
                                  {{ GetCodeById(row.id) }}</a
                                >                               
                              </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Tipo" [width]="100" prop="shippingTypeName"></ngx-datatable-column>
                        <ngx-datatable-column name="Descripción" [width]="120" prop="description">
                            <ng-template let-description="value" ngx-datatable-cell-template>
                                {{description | limitText}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Creado En" [width]="100" prop="createAt">
                            <ng-template let-createAt="value" ngx-datatable-cell-template>
                                {{createAt | date: 'dd/MM/yyyy'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Gastos" [width]="100" prop="totalCost">
                            <ng-template let-totalCost="value" ngx-datatable-cell-template>
                                {{totalCost | currency}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Estado" [width]="90" prop="closeAt">
                            <ng-template let-closeAt="value" ngx-datatable-cell-template>
                                <div class="badge badge-pill"
                                    [ngClass]="{
                                        'badge-light-primary': GetState(closeAt),
                                        'badge-light-danger': !GetState(closeAt)
                                    }">
                                    {{ GetState(closeAt) ? 'Abierto' : 'Cerrada' }}
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Acciones" [width]="180" [sortable]="false" prop="id">
                            <ng-template ngx-datatable-cell-template let-shippingId="value">
                                <button class="btn btn-outline-light text-primary dropbtn" [ngbPopover]="popoverTemplate"
                                #popOver="ngbPopover" data-container="body" placement="left-top"
                                [autoClose]="'outside'" type="button" id="defaultDropdown" aria-expanded="false">
                                    <em class="fa fa-bars"></em>
                                </button> 
                                <ng-template #popoverTemplate style="overflow: visible;">                                             
                                                <div>
                                                    <button type="button" ngbTooltip="Vuelos" placement="left"
                                                        class="btn btn-outline-primary btn-icon text-primary cursor-pointer mr-50"
                                                        rippleEffect (click)="OpenFlightsModal(shippingId)">
                                                        <span [data-feather]="'send'"></span></button>
                                                        <button type="button" ngbTooltip="Gastos" placement="left"
                                                        class="btn btn-outline-success btn-icon text-success cursor-pointer mr-50"
                                                        rippleEffect (click)="OpenExpensesModal(shippingId)">
                                                        <span [data-feather]="'file-text'"></span></button>
                                                        <button type="button" ngbTooltip="Editar" placement="left"
                                                        class="btn btn-outline-info btn-icon text-info cursor-pointer mr-50"
                                                        rippleEffect (click)="OpenCreateModal(shippingId)">
                                                        <span [data-feather]="'edit'"></span></button>
                                                        <button type="button" (click)="Delete(shippingId)" ngbTooltip="Eliminar"
                                                            placement="left" *ngIf="ShowDelete(shippingId)"
                                                            class="btn btn-outline-danger btn-icon text-danger cursor-pointer" rippleEffect>
                                                            <span [data-feather]="'trash-2'"></span></button>
                                                </div>
                                                                     
                                  </ng-template>
                                
                                
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>-->

                </div>
            </div>
        </section>
        
    </div>
</div>
<ng-template #myModal>
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">Filtrar</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        gdfgdfg
    </div>
    
</ng-template>